import { BaseModel } from "./base"
import { Device } from "./device";
import { JsonProperty } from "../requests/jsonparser";
import { Subscription } from "./subscription";
import { Account } from './account';

export class User extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'User' })
    MODELNAME: string;


    @JsonProperty({ type: 'string?' })
    email?: string;

    @JsonProperty({ type: 'string' })
    full_name: string;

    @JsonProperty({ type: 'Account', clazz: Account })
    account: Account;

    @JsonProperty({ clazz: Device, type: 'Device?' })
    devices?: Device[];

    @JsonProperty({ clazz: Subscription, type: 'Subscription?' })
    subscriptions?: Subscription[];

    @JsonProperty({ type: 'string?' })
    profile_image_url?: string;

    @JsonProperty({ type: 'string?' })
    profile_image_thumbnail_url?: string;

    @JsonProperty({ type: 'string?' })
    refresh_token: string | undefined;

    @JsonProperty({ type: 'boolean?' })
    verified?: boolean;

    @JsonProperty({ type: 'boolean?' })
    is_admin?: boolean;


    public hasValidSubscription() {
        return this.getValidSubscription() != undefined
    }

    public getValidSubscription() {
        if (this.subscriptions && this.subscriptions.length) {
            let valid = this.subscriptions.find(sub => {
                return sub.start_date <= new Date() && (!sub.expire_date || sub.expire_date > new Date())
            })
            if (valid) {
                return valid
            }
        }
        return undefined
    }
}



// WEBPACK FOOTER //
// ./src/api/models/user.ts